import React from "react";
import ReactDOM from "react-dom";
import configureStore from "./store/configureStore";
import "./index.css";
import { AppRouter } from "./router/route";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import jquery from "jquery";
window.$ = window.jQuery = jquery;

import "bootstrap/dist/css/bootstrap.css";
import "animate.css/animate.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./styles/styles.css";


const store = configureStore();


ReactDOM.render(
    <AppRouter store={store} />
    , document.getElementById("root")
);
unregisterServiceWorker();
